export default {
  init() {
    const files = require.context('!svg-sprite-loader!../../icons/', false, /.*\.svg$/);
    files.keys().forEach(files);
  },
};
